import React from "react";

interface HeaderProps {
  showForm: boolean;
  formToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ showForm, formToggle }) => {
  return (
    <div className="header">
      <div className="logoHeading">
        <svg
          width="13mm"
          height="13mm"
          version="1.1"
          viewBox="0 0 127.84 118.94"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(-34.306 -4.8491)">
            <path
              transform="matrix(.23457 0 0 .22874 3.9196 .69192)"
              d="m231.15 533.94 33.873-186.48-134.41-133.62 187.82-25.409 85.545-169.12 82.205 170.77 187.28 29.096-137.01 130.95 30.202 187.11-166.88-89.84z"
              fill="#cea474"
              stroke="#000"
            />
            <g fill="none" stroke="#000" strokeWidth=".26458px">
              <path d="m98.681 5.1075-0.98693 97.921" />
              <path d="m34.557 49.605 95.199 31.175" />
              <path d="m58.141 122.82 59.823-78.654" />
              <path d="m161.9 50.826-95.809 29.344" />
              <path d="m136.84 123.58-58.226-79.786" />
            </g>
            <g fill="#3d1d10" stroke="#3d1d10" strokeWidth=".3377">
              <path
                transform="scale(.26458)"
                d="m371.28 249.73c0.12002-7.8938 0.66896-60.474 1.2199-116.84 0.55089-56.371 1.0383-104.35 1.0832-106.63l0.0816-4.1327 35.604 72.18c19.582 39.699 35.643 72.263 35.689 72.364 0.0634 0.13768-54.282 71.797-71.699 94.541l-2.1981 2.8705z"
              />
              <path
                transform="scale(.26458)"
                d="m431.19 285.24-58.313-19.134 1.7476-0.58466c3.1858-1.0658 234.39-71.828 234.45-71.755 0.17683 0.22301-118.55 110.51-119.01 110.55-0.30876 0.0295-26.802-8.5565-58.874-19.08z"
              />
              <path
                transform="scale(.26458)"
                d="m442.22 427.01c-39.562-20.788-72.019-37.838-72.127-37.889-0.18609-0.0883 0.90351-117.41 1.1118-119.71 0.0882-0.97485 7.2892 8.7695 70.847 95.868 38.912 53.324 71.18 97.541 71.706 98.259 0.52684 0.71787 0.83077 1.2972 0.6754 1.2873-0.15537-0.01-32.651-17.026-72.213-37.814z"
              />
              <path
                transform="scale(.26458)"
                d="m221.19 460.37c0-0.53866 29.04-156.74 29.156-156.82 0.19256-0.13914 117.93-36.137 118.01-36.08 0.1071 0.0762-145.91 192.17-146.69 192.97-0.41838 0.43319-0.47758 0.42447-0.47758-0.0703z"
              />
              <path
                transform="scale(.26458)"
                d="m250.84 226.16c-64.396-21.104-117.05-38.4-117.01-38.438 0.2258-0.21438 162.43-21.443 162.79-21.305 0.34361 0.13186 70.529 95.943 71.58 97.715 0.14853 0.2504 0.14853 0.44234 0 0.42654s-52.958-17.295-117.35-38.399z"
              />
            </g>
          </g>
        </svg>
        <h1>Noble notes</h1>
      </div>
      <button onClick={formToggle}>
        {showForm ? "- close" : "+ add note"}
      </button>
    </div>
  );
};

export default Header;
